(function () {
  "use strict";

  /* =========================================================
     CONFIG — edit to match your store
     ========================================================= */
  var CONFIG = {
    // Must match the Option name in Shopify admin exactly (e.g. "Size" or "Age").
    variantOptionName: "Size",

    // Auto-open the popup the first time a shopper clicks a size swatch
    // on the page. Fires on every fresh page load/refresh (not remembered
    // across visits). Set to false to disable entirely.
    autoOpenOnVariantClick: true,
    autoOpenTriggerSelector: '.block-swatch-list .block-swatch__item, .block-swatch-list input[type="radio"]'
  };

  /* =========================================================
     FIELD REGISTRY
     Every measurement the popup can possibly ask for. Each
     category below picks a subset via `bodyFields` — the form
     shows only those, in this order, and only those are used
     for matching.
     ========================================================= */
  var FIELD_ORDER = ["chest", "waist", "shoulderKnee", "waistAnkle"];

  /* =========================================================
     SHARED BODY CHART
     Tunic Set (both lengths), Bandhani Plazo, Farsi Set,
     Lakhnavi Dhoti Set, and Short Tunic Plazo Set all use this
     exact same body-measurement chart in the PDF — only their
     garment measurements differ.
     ========================================================= */
  var BODY_4FIELD = [
    { age: "1-2Y", chest: 19, waist: 19, shoulderKnee: 16,   waistAnkle: 17   },
    { age: "2-3Y", chest: 20, waist: 20, shoulderKnee: 18.5, waistAnkle: 19   },
    { age: "3-4Y", chest: 21, waist: 21, shoulderKnee: 20.5, waistAnkle: 23   },
    { age: "4-5Y", chest: 22, waist: 22, shoulderKnee: 22.5, waistAnkle: 25.5 },
    { age: "5-6Y", chest: 23, waist: 23, shoulderKnee: 25,   waistAnkle: 26.5 },
    { age: "6-7Y", chest: 24, waist: 24, shoulderKnee: 27,   waistAnkle: 28   },
    { age: "7-8Y", chest: 25, waist: 25, shoulderKnee: 29.5, waistAnkle: 30.5 },
    { age: "8-9Y", chest: 26, waist: 26, shoulderKnee: 31.5, waistAnkle: 32.5 }
  ];

  /* =========================================================
     SIZE_CHARTS — one entry per product category. Add new
     categories here as new charts come in.

     Shape of each entry:
       {
         label: "Human name, for your reference in comments only",
         bodyFields: [subset of FIELD_ORDER],   // drives which
                                                 // inputs show & are matched
         body: [ { age, ...bodyFields }, ... ],
         garmentFields: [ { key, label }, ... ], // drives the result table
         garment: { "<age>": { ...garmentFields keys }, ... }
       }

     `body: null` makes the popup show a "coming soon" message
     instead of a form — use that for any category you haven't
     gotten numbers for yet.
     ========================================================= */
  var SIZE_CHARTS = {

    "tunic-set-till-knee": {
      label: "Tunic Set (Pattern 1 — Till Knee)",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "topLength", label: "Top length (till knee)" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, topLength: 16,   waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, topLength: 18.5, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, topLength: 20.5, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, topLength: 22.5, waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, topLength: 25,   waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, topLength: 27,   waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, topLength: 29.5, waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, topLength: 31.5, waist: 24, pantLength: 31.5 }
      }
      // SKUs on this chart per the PDF: 891, 892, 894, 893, 895, 896, 897,
      // 898, 888, 887, 640, 638, 719, 718
    },

    "tunic-set-below-knee": {
      label: "Tunic Set (Pattern 2 — Below Knee)",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "topLength", label: "Top length (below knee)" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, topLength: 18,   waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, topLength: 21.5, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, topLength: 24.5, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, topLength: 27,   waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, topLength: 29,   waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, topLength: 31,   waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, topLength: 33,   waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, topLength: 35,   waist: 24, pantLength: 31.5 }
      }
      // SKUs on this chart per the PDF: 905, 798, 889, 890, 722, 720, 721,
      // 614, 808, 809, 801, 761, 613, 760, 799, 793
    },

    "bandhani-plazo": {
      label: "Bandhani Plazo",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, aboveKnee: 22, waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, aboveKnee: 23, waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, aboveKnee: 24, waist: 24, pantLength: 31.5 }
      }
      // SKU on this chart per the PDF: 903
    },

    "farsi-set": {
      label: "Farsi Set",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "farsiLength", label: "Farsi length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, farsiLength: 18 },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, farsiLength: 21 },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, farsiLength: 24 },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, farsiLength: 26 },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, farsiLength: 28 },
        "6-7Y": { chest: 27, aboveKnee: 22, waist: 22, farsiLength: 30 },
        "7-8Y": { chest: 28, aboveKnee: 23, waist: 23, farsiLength: 32 },
        "8-9Y": { chest: 30, aboveKnee: 24, waist: 24, farsiLength: 34 }
      }
      // SKUs on this chart per the PDF: 908, 907
    },

    "lakhnavi-dhoti-set": {
      label: "Lakhnavi Dhoti Set",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "dhotiLength", label: "Dhoti length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, dhotiLength: 18 },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, dhotiLength: 21 },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, dhotiLength: 24 },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, dhotiLength: 26 },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, dhotiLength: 28 },
        "6-7Y": { chest: 27, aboveKnee: 23, waist: 22, dhotiLength: 30 },
        "7-8Y": { chest: 28, aboveKnee: 25, waist: 23, dhotiLength: 32 },
        "8-9Y": { chest: 30, aboveKnee: 27, waist: 24, dhotiLength: 34 }
      }
      // SKUs on this chart per the PDF: 943, 942, 941
    },

    "short-tunic-plazo-set": {
      label: "Short Tunic Plazo Set",
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "plazoLength", label: "Plazo length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, plazoLength: 16   },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, plazoLength: 18   },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, plazoLength: 22   },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, plazoLength: 24   },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, plazoLength: 25.5 },
        "6-7Y": { chest: 27, aboveKnee: 23, waist: 22, plazoLength: 27   },
        "7-8Y": { chest: 28, aboveKnee: 25, waist: 23, plazoLength: 29.5 },
        "8-9Y": { chest: 30, aboveKnee: 27, waist: 24, plazoLength: 31.5 }
      }
      // SKUs on this chart per the PDF: 936, 935, 806, 807
    },

    "boy-kurta-set": {
      label: "Boy Kurta Set (standard, applies to all)",
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 20, waist: 19, waistAnkle: 17   },
        { age: "2-3Y", chest: 21, waist: 20, waistAnkle: 19   },
        { age: "3-4Y", chest: 22, waist: 21, waistAnkle: 23   },
        { age: "4-5Y", chest: 23, waist: 22, waistAnkle: 25.5 },
        { age: "5-6Y", chest: 24, waist: 23, waistAnkle: 26.5 },
        { age: "6-7Y", chest: 25, waist: 24, waistAnkle: 28   },
        { age: "7-8Y", chest: 26, waist: 25, waistAnkle: 30.5 },
        { age: "8-9Y", chest: 27, waist: 26, waistAnkle: 32.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "pantLength", label: "Pant length" }
      ],
      garment: {
        "1-2Y": { chest: 25, elasticWaist: 16, pantLength: 18   },
        "2-3Y": { chest: 26, elasticWaist: 17, pantLength: 21   },
        "3-4Y": { chest: 27, elasticWaist: 18, pantLength: 24   },
        "4-5Y": { chest: 28, elasticWaist: 19, pantLength: 25.5 },
        "5-6Y": { chest: 29, elasticWaist: 20, pantLength: 27   },
        "6-7Y": { chest: 30, elasticWaist: 21, pantLength: 28.5 },
        "7-8Y": { chest: 31, elasticWaist: 22, pantLength: 30   },
        "8-9Y": { chest: 32, elasticWaist: 23, pantLength: 31.5 }
      }
      // Marked "standard size for all boy kurta set" in the PDF — no
      // per-SKU list given, applies across the whole category.
    },

    "lehenga": {
      label: "Lehenga (standard, applies to all)",
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 19, waist: 19, waistAnkle: 17 },
        { age: "2-3Y", chest: 20, waist: 20, waistAnkle: 19 },
        { age: "3-4Y", chest: 21, waist: 21, waistAnkle: 21 },
        { age: "4-5Y", chest: 22, waist: 22, waistAnkle: 22 },
        { age: "5-6Y", chest: 23, waist: 23, waistAnkle: 25 },
        { age: "6-7Y", chest: 24, waist: 24, waistAnkle: 26 },
        { age: "7-8Y", chest: 25, waist: 25, waistAnkle: 27 },
        { age: "8-9Y", chest: 26, waist: 26, waistAnkle: 30 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "lehengaLength", label: "Lehenga length" }
      ],
      garment: {
        "1-2Y": { chest: 22, elasticWaist: 17, lehengaLength: 19 },
        "2-3Y": { chest: 23, elasticWaist: 18, lehengaLength: 21 },
        "3-4Y": { chest: 24, elasticWaist: 19, lehengaLength: 23 },
        "4-5Y": { chest: 25, elasticWaist: 20, lehengaLength: 25 },
        "5-6Y": { chest: 26, elasticWaist: 21, lehengaLength: 27 },
        "6-7Y": { chest: 27, elasticWaist: 22, lehengaLength: 29 },
        "7-8Y": { chest: 28, elasticWaist: 23, lehengaLength: 31 },
        "8-9Y": { chest: 30, elasticWaist: 24, lehengaLength: 33 }
      }
      // Marked "standard size for all girl Lehenga set" in the PDF.
    },

    "co-ord-set": {
      label: "Co-ord Set (standard, applies to all)",
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 19, waist: 19, waistAnkle: 17   },
        { age: "2-3Y", chest: 20, waist: 20, waistAnkle: 19   },
        { age: "3-4Y", chest: 21, waist: 21, waistAnkle: 23   },
        { age: "4-5Y", chest: 22, waist: 22, waistAnkle: 25.5 },
        { age: "5-6Y", chest: 23, waist: 23, waistAnkle: 26.5 },
        { age: "6-7Y", chest: 24, waist: 24, waistAnkle: 28   },
        { age: "7-8Y", chest: 25, waist: 25, waistAnkle: 30.5 },
        { age: "8-9Y", chest: 26, waist: 26, waistAnkle: 32.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "pantLength", label: "Pant length" }
      ],
      garment: {
        "1-2Y": { chest: 22, elasticWaist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, elasticWaist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, elasticWaist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, elasticWaist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, elasticWaist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, elasticWaist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, elasticWaist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, elasticWaist: 24, pantLength: 31.5 }
      }
      // Marked "standard size for all girl co-ord set" in the PDF.
    },

    "dress": {
      label: "Dress (standard, applies to all)",
      bodyFields: ["chest", "shoulderKnee"],
      body: [
        { age: "1-2Y", chest: 19, shoulderKnee: 16   },
        { age: "2-3Y", chest: 20, shoulderKnee: 18.5 },
        { age: "3-4Y", chest: 21, shoulderKnee: 20.5 },
        { age: "4-5Y", chest: 22, shoulderKnee: 22.5 },
        { age: "5-6Y", chest: 23, shoulderKnee: 25   },
        { age: "6-7Y", chest: 24, shoulderKnee: 27   },
        { age: "7-8Y", chest: 25, shoulderKnee: 29.5 },
        { age: "8-9Y", chest: 27, shoulderKnee: 31.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "dressLength", label: "Dress length" }
      ],
      garment: {
        "1-2Y": { chest: 22, dressLength: 16   },
        "2-3Y": { chest: 23, dressLength: 18.5 },
        "3-4Y": { chest: 24, dressLength: 20.5 },
        "4-5Y": { chest: 25, dressLength: 22.5 },
        "5-6Y": { chest: 26, dressLength: 25   },
        "6-7Y": { chest: 27, dressLength: 27   },
        "7-8Y": { chest: 28, dressLength: 29.5 },
        "8-9Y": { chest: 30, dressLength: 31.5 }
      }
      // Marked "standard size for all girl Dresses" in the PDF.
    }
  };

  /* =========================================================
     SKU_TO_CATEGORY — PRIMARY detection method.
     Maps a base SKU code to its category slug. A variant's SKU
     may have a trailing letter for color (e.g. "614", "614L",
     "614G" are all the same base code "614" in different
     colors) — that suffix is stripped automatically by
     baseSkuCode() below, so only list the plain numeric code
     here once.

     Filled in chart-by-chart as each one is confirmed. Charts
     not yet listed here fall through to tag-based detection
     (see the Liquid file) or, if nothing matches, the widget
     doesn't render for that product at all.
     ========================================================= */
  var SKU_TO_CATEGORY = {
    // ---- Tunic Set — Till Knee (Pattern 1) — CONFIRMED ----
    "891": "tunic-set-till-knee",
    "892": "tunic-set-till-knee",
    "894": "tunic-set-till-knee",
    "893": "tunic-set-till-knee",
    "895": "tunic-set-till-knee",
    "896": "tunic-set-till-knee",
    "897": "tunic-set-till-knee",
    "898": "tunic-set-till-knee",
    "888": "tunic-set-till-knee",
    "887": "tunic-set-till-knee",
    "640": "tunic-set-till-knee",
    "638": "tunic-set-till-knee",
    "719": "tunic-set-till-knee",
    "718": "tunic-set-till-knee",

    // ---- Tunic Set — Below Knee (Pattern 2) — CONFIRMED ----
    // 614 has three color SKUs: 614, 614L, 614G
    // 613 only exists as: 613Y, 613M (no plain "613" SKU)
    "905": "tunic-set-below-knee",
    "798": "tunic-set-below-knee",
    "889": "tunic-set-below-knee",
    "890": "tunic-set-below-knee",
    "722": "tunic-set-below-knee",
    "720": "tunic-set-below-knee",
    "721": "tunic-set-below-knee",
    "614": "tunic-set-below-knee",
    "614L": "tunic-set-below-knee",
    "614G": "tunic-set-below-knee",
    "808": "tunic-set-below-knee",
    "809": "tunic-set-below-knee",
    "801": "tunic-set-below-knee",
    "761": "tunic-set-below-knee",
    "613Y": "tunic-set-below-knee",
    "613M": "tunic-set-below-knee",
    "760": "tunic-set-below-knee",
    "799": "tunic-set-below-knee",
    "793": "tunic-set-below-knee",

    // ---- Bandhani Plazo — CONFIRMED ----
    "903": "bandhani-plazo",

    // ---- Farsi Set — CONFIRMED ----
    "908": "farsi-set",
    "907": "farsi-set",

    // ---- Lakhnavi Dhoti Set — CONFIRMED ----
    "943": "lakhnavi-dhoti-set",
    "942": "lakhnavi-dhoti-set",
    "941": "lakhnavi-dhoti-set",

    // ---- Short Tunic Plazo Set — CONFIRMED ----
    "936": "short-tunic-plazo-set",
    "935": "short-tunic-plazo-set",
    "806": "short-tunic-plazo-set",
    "807": "short-tunic-plazo-set",

    // Boy Kurta Set / Lehenga / Co-ord Set / Dress are "standard,
    // applies to all" in the PDF (no per-product SKU list), so
    // they're detected by tag instead — see the Liquid file.
  };

  // Strips a trailing color-letter suffix off a variant SKU and
  // returns the leading numeric base code, e.g. "614L" -> "614".
  function baseSkuCode(sku) {
    if (!sku) return "";
    var m = String(sku).trim().match(/^(\d+)/);
    return m ? m[1] : "";
  }

  function detectCategoryFromSkus(skuList) {
    for (var i = 0; i < skuList.length; i++) {
      var raw = String(skuList[i]).trim();
      if (!raw) continue;

      // Try the exact SKU first (handles cases like "613Y"/"613M" where
      // only the lettered SKUs exist, not a bare base code).
      if (SKU_TO_CATEGORY[raw]) return SKU_TO_CATEGORY[raw];

      // Fall back to the numeric base code (handles cases like "614L"/
      // "614G" where the base code "614" is listed once and covers all
      // its color variants).
      var base = baseSkuCode(raw);
      if (base && SKU_TO_CATEGORY[base]) return SKU_TO_CATEGORY[base];
    }
    return null;
  }

  /* Normalization range per field, computed per category (only over the
     fields that category actually uses) so measurements on very
     different scales don't distort the match. */
  function max(arr, key) { return arr.reduce(function (m, r) { return Math.max(m, r[key]); }, -Infinity); }
  function min(arr, key) { return arr.reduce(function (m, r) { return Math.min(m, r[key]); }, Infinity); }

  function computeFieldRange(bodyChart, fields) {
    var range = {};
    fields.forEach(function (f) {
      range[f] = max(bodyChart, f) - min(bodyChart, f);
    });
    return range;
  }

  /* =========================================================
     MATCHING LOGIC
     Finds the bracket whose weighted normalized distance to the
     entered measurements is smallest, using only the fields the
     active category defines.
     ========================================================= */
  function findBestMatch(input, bodyChart, fields, fieldRange) {
    var best = null;
    var bestScore = Infinity;

    bodyChart.forEach(function (row) {
      var score = 0;
      fields.forEach(function (f) {
        var diff = (input[f] - row[f]) / (fieldRange[f] || 1);
        score += diff * diff;
      });

      if (score < bestScore) {
        bestScore = score;
        best = row;
      }
    });

    return best;
  }

  /* =========================================================
     VARIANT AUTO-SELECT
     Many themes (including block-swatch-list style markup)
     render option radios OUTSIDE the <form> element and
     associate them via the HTML `form="..."` attribute instead
     of DOM nesting, so this searches the whole document. It
     also matches by the swatch's visible <label> text, since
     the radio's `value` is often the numeric variant ID, not
     the size text (e.g. value="7328895074672", label "1-2Y").
     ========================================================= */
  function selectVariantOption(sizeLabel) {
    var target = sizeLabel.trim().toLowerCase();

    // 1) Native <select>
    var select = document.querySelector('select[name*="' + CONFIG.variantOptionName + '" i], select[id*="' + CONFIG.variantOptionName + '" i]');
    if (select) {
      var opt = Array.prototype.find.call(select.options, function (o) {
        return o.value.trim().toLowerCase() === target || o.textContent.trim().toLowerCase() === target;
      });
      if (opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }

    // 2) <label for="..."> whose visible text is the size (block-swatch
    //    style pickers). Clicking the label is what real users do, and
    //    it triggers whatever the theme's own swatch JS listens for.
    var labels = document.querySelectorAll("label[for]");
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase() === target) {
        labels[i].click();
        return true;
      }
    }

    // 3) Radio inputs whose own value happens to be the size text.
    var radios = document.querySelectorAll('input[type="radio"][value]');
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].value.trim().toLowerCase() === target) {
        radios[j].checked = true;
        radios[j].dispatchEvent(new Event("change", { bubbles: true }));
        radios[j].dispatchEvent(new Event("click", { bubbles: true }));
        return true;
      }
    }

    // 4) Plain button swatches with the size as their visible text.
    var buttons = document.querySelectorAll("button");
    for (var k = 0; k < buttons.length; k++) {
      if (buttons[k].textContent.trim().toLowerCase() === target) {
        buttons[k].click();
        return true;
      }
    }

    return false;
  }

  /* =========================================================
     WIRE UP THE UI
     Elements are looked up by class, scoped to each `.size-rec`
     root via querySelector — not by concatenating IDs, so
     nothing breaks if block IDs don't line up perfectly (e.g.
     duplicate renders in the theme editor preview).
     ========================================================= */
  document.querySelectorAll(".size-rec").forEach(function (root) {
    var openBtn    = root.querySelector(".size-rec__trigger");
    var overlay    = root.querySelector(".size-rec__overlay");
    var closeBtn   = root.querySelector(".size-rec__close");
    var form       = root.querySelector(".size-rec__form");
    var resultBox  = root.querySelector(".size-rec__result");
    var emptyBox   = root.querySelector(".size-rec__empty");

    if (!openBtn || !overlay || !closeBtn || !form || !resultBox) return;

    var skuAttr    = root.getAttribute("data-skus") || "";
    var skuList    = skuAttr.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    var collectionCategory = root.getAttribute("data-collection-category") || "";
    var forceShow   = root.getAttribute("data-force-show") === "true";
    var forceCategory = root.getAttribute("data-force-category") || "";
    var productId = root.getAttribute("data-product-id") || "unknown-product";

    // Resolution order: SKU match (primary) -> collection-pair match
    // (fallback, for the "standard" categories) -> Force show setting.
    var category = detectCategoryFromSkus(skuList) || (collectionCategory || null) || (forceShow ? forceCategory : null);

    // Nothing matched at all — don't show the widget for this product.
    if (!category) {
      root.remove();
      return;
    }

    var chart     = SIZE_CHARTS[category];
    var hasChart  = !!(chart && chart.body && chart.garment);
    var fieldRange = hasChart ? computeFieldRange(chart.body, chart.bodyFields) : null;

    // Show/hide the 5 possible input fields based on what this
    // category actually needs, and keep `required` only on visible ones.
    FIELD_ORDER.forEach(function (f) {
      var wrapper = form.querySelector('[data-field="' + f + '"]');
      if (!wrapper) return;
      var input = wrapper.querySelector("input");
      var active = hasChart && chart.bodyFields.indexOf(f) !== -1;
      wrapper.hidden = !active;
      if (input) input.required = active;
    });

    // No measurements loaded yet for this category — show the
    // "coming soon" message instead of a form that can't work.
    if (!hasChart) {
      form.hidden = true;
      if (emptyBox) emptyBox.hidden = false;
    }

    function openModal() {
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    openBtn.addEventListener("click", function (e) {
      e.preventDefault(); // trigger is an <a href="#">, don't navigate
      openModal();
    });

    // Auto-open the first time a shopper clicks any size swatch, on
    // this page view. Uses only an in-memory flag — nothing is
    // persisted — so it fires again every time the page is loaded or
    // refreshed, including when returning to the same product.
    if (hasChart && CONFIG.autoOpenOnVariantClick) {
      var triggerEls = document.querySelectorAll(CONFIG.autoOpenTriggerSelector);
      var fired = false;
      triggerEls.forEach(function (el) {
        el.addEventListener("click", function () {
          if (fired) return;
          fired = true;
          // Let the normal swatch selection happen too — this just
          // additionally opens the helper popup alongside it.
          openModal();
        });
      });
    }

    function closeModal() {
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
      resetForm();
    }

    function resetForm() {
      form.reset();
      resultBox.hidden = true;
      resultBox.innerHTML = "";
    }

    closeBtn.addEventListener("click", closeModal);

    // Escape key also closes it — handy fallback if a click target
    // ever gets covered by something in a theme's own CSS.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeModal();
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!hasChart) return;

      var data = new FormData(form);
      var input = {};
      var allValid = true;
      chart.bodyFields.forEach(function (f) {
        var v = parseFloat(data.get(f));
        input[f] = v;
        if (isNaN(v)) allValid = false;
      });
      if (!allValid) return;

      var match = findBestMatch(input, chart.body, chart.bodyFields, fieldRange);
      var garment = chart.garment[match.age];
      var selected = selectVariantOption(match.age);

      var rowsHtml = chart.garmentFields.map(function (f) {
        return '<tr><td>' + f.label + '</td><td>' + garment[f.key] + '"</td></tr>';
      }).join("");

      resultBox.hidden = false;
      resultBox.innerHTML =
        '<div class="size-rec__result-size">Recommended: ' + match.age + '</div>' +
        '<div class="size-rec__result-note">' +
          (selected
            ? "We've selected this size for you below."
            : "Select <strong>" + match.age + "</strong> in the size options below.") +
        '</div>' +
        '<table class="size-rec__result-table">' + rowsHtml + '</table>' +
        '<button type="button" class="size-rec__result-cta">Done</button>';

      var doneBtn = resultBox.querySelector(".size-rec__result-cta");
      if (doneBtn) doneBtn.addEventListener("click", closeModal);

      // Bring the result into view — the modal body scrolls, so the
      // result can otherwise land below the fold after submitting.
      resultBox.scrollIntoView({ behavior: "smooth", block: "start" });

      // Fires a custom event in case you want to hook this into a
      // different theme's variant picker instead of editing
      // selectVariantOption() above.
      root.dispatchEvent(new CustomEvent("size-rec:matched", {
        bubbles: true,
        detail: { category: category, productId: productId, age: match.age, garment: garment }
      }));
    });
  });
})();